import React from 'react';
import { AlertModal, ProgressIndicator } from '@veneer/core';
import {
  numberFormatComma,
  numberFormatCommaMinimunFraction,
  numberFormatCommaTwoFraction,
} from './../../../common/js/utils/numberFormat';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import moment from 'moment';
const CPP = (props) => {
  const {
    press,
    onClickUnderstandCalc,
    costPerPrint,
    consolidatePrintVolumeReport,
    isLoading
  } = props;
  
  const { t, i18n } = useTranslation();
  const specialCondition = consolidatePrintVolumeReport.find(
    (item) => item.endDate != null && item.idPress === press.idPress
  );

  const cpp = press.series == 3 && press.compensationProgram == 1 ? numberFormatCommaMinimunFraction(costPerPrint?.cppAfterCompensation) || '-' : (
    (press.series != '4' && costPerPrint?.costPerPrint == null) ||
      (press.series == '4'  && costPerPrint?.cppAfterCompensation == null)
      ? '-'
      : press.series != '4' 
        ? numberFormatCommaMinimunFraction(costPerPrint?.costPerPrint)
        : numberFormatCommaMinimunFraction(costPerPrint?.cppAfterCompensation)
  )
    const CPP2 = () => {
      if ((press.series=='3' &&  press.compensationProgram == 1) || (press.series=='4' || press.series=='5' || press.series=='6')){
        return (numberFormatCommaMinimunFraction(costPerPrint?.cppAfterCompensation));
      }else if(costPerPrint?.costPerPrint!=null || costPerPrint?.costPerPrint!=''){
        return numberFormatCommaMinimunFraction(costPerPrint?.costPerPrint);
      }else{
        return '-';
      }
    }

  /*const a34 = press.series == 3 && press.compensationProgram == 1 ? numberFormatCommaMinimunFraction(costPerPrint?.cppAfterCompensation * 4) || '-' : (
    (press.series != '4' && costPerPrint?.costPerPrint4Color == null) ||
      (press.series == '4' && costPerPrint?.cppAfterCompensation == null)
      ? '-'
      : press.series != '4'
        ? numberFormatCommaMinimunFraction(costPerPrint?.costPerPrint4Color)
        : numberFormatCommaMinimunFraction(costPerPrint?.cppAfterCompensation * 4)
  )*/
  const A34=()=>{
    if ((press.series=='3' &&  press.compensationProgram == 1) || (press.series=='4' || press.series=='5' || press.series=='6')){
      return (numberFormatCommaMinimunFraction(costPerPrint?.cppAfterCompensation * 4));
    }else if(costPerPrint?.costPerPrint4Color!=null || costPerPrint?.costPerPrint4Color!=''){
      return numberFormatCommaMinimunFraction(costPerPrint?.costPerPrint4Color);
    }else{
      return '-';
    }
  }

  if (isLoading || costPerPrint === undefined) {
    return <ProgressIndicator appearance="linear" />
  }

  return costPerPrint === undefined ? (
    <>
      <div className="table-responsive">
        <table className="table table-striped table-sm">
          <tbody>{t('error.gettingData')}</tbody>
        </table>
      </div>
      {t('report.details.cpp.info')}
    </>
  ) : (
    <>
      <div className="table-responsive">
        <table className="table table-striped table-sm">
          <tbody>
            <tr>
              <th>{t('press id')}</th>
              <td colSpan="2">{press.idPress}</td>
            </tr>
            <tr>
              <th>{t('cost per print')} </th>
              <td>US$ <CPP2/></td>
              <td>
                <a href="#" onClick={onClickUnderstandCalc}>
                  » {t('button.understandCalc')}
                </a>
              </td>
            </tr>
            <tr>
              <th>{t('A3 4 Colors Cost')}</th>
              <td colSpan="2"> US$ <A34/></td>
            </tr>
            {specialCondition != undefined ? (
              <tr>
                <th>Special Condition</th>
                <td colSpan="2">
                  {moment(specialCondition.endDate).format('DD/MMM/YYYY')}
                </td>
              </tr>
            ) : undefined}
          </tbody>
        </table>
      </div>
      {t('report.details.cpp.info')}
    </>
  );
};

const SuppliesReport = (props) => {
  const { suppliesReport, press, isLoading } = props;
  const { t, i18n } = useTranslation();
  const data1 = suppliesReport.find((e) => e.idPress === press.idPress);
  const data = data1 === undefined ? [] : data1.suppliesReport;
  let total = 0;
  let totalPercentage = 0;
  let countPercentage = 0;
  const isAverageAmong = (idConsumableType) => {
    switch (idConsumableType) {
      case 1:
        return '*';
      case 2:
        return '*';
      case 3:
        return '*';
      case 4:
        return '*';
      default:
        return '';
    }
  };

  if (isLoading) {
    return <ProgressIndicator appearance="linear" />
  }

  return (
    <div className="table-responsive">
      <table className="table table-striped table-hover table-bordered table-sm">
        <thead>
          <tr>
            <th scope="col">Description</th>
            <th scope="col">Used Quantity This Month</th>
            <th scope="col">Used Quantity (Period)</th>
            <th scope="col">Unit price (US$)</th>
            <th scope="col">Total (US$)</th>
            <th scope="col">LifeSpan Calculated¹</th>
            <th scope="col">LifeSpan HP A3²</th>
            <th scope="col">Life Span Percentage³</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            total = total + row.totalPrice;
            totalPercentage = totalPercentage + row.lifeSpanPercentage;
            countPercentage =
              row.lifeSpanPercentage === null
                ? countPercentage
                : countPercentage + 1;
            if (row.idConsumableType === 10) {
              row.thisMonthTotal = null;
              row.thisPeriodTotal = null;
            }
            return (
              <tr key={row.idConsumableType}>
                <td align="right" style={{ whiteSpace: 'nowrap' }}>
                  {row.consumable}
                </td>
                <td align="right">
                  {row.thisMonthTotal === null
                    ? '-'
                    : numberFormatComma(row.thisMonthTotal)}
                </td>
                <td align="right">
                  {row.thisPeriodTotal === null
                    ? '-'
                    : numberFormatComma(row.thisPeriodTotal)}
                </td>
                <td align="right">
                  {row.unitPrice === null
                    ? '-'
                    : numberFormatCommaTwoFraction(row.unitPrice)}
                </td>
                <td align="right">
                  {row.totalPrice === null
                    ? '-'
                    : numberFormatCommaTwoFraction(row.totalPrice)}
                </td>
                <td align="right">
                  {row.lifeSpanCalculated === null
                    ? '-'
                    : numberFormatComma(row.lifeSpanCalculated)}{' '}
                  {isAverageAmong(row.idConsumableType)}
                </td>
                <td align="right">
                  {row.lifeSpanHPA3 === null
                    ? '-'
                    : numberFormatComma(row.lifeSpanHPA3)}
                </td>
                <td align="center">
                  {row.lifeSpanPercentage === null
                    ? '-'
                    : numberFormatCommaTwoFraction(row.lifeSpanPercentage)}{' '}
                  %
                </td>
              </tr>
            );
          })}
          <tr>
            <th colSpan="4" className="text-right">
              Total (US$)
            </th>
            <th className="text-right">
              {numberFormatCommaTwoFraction(total)}
            </th>
            <td></td>
            <td></td>
            {/* {
              <th className="text-center">
                {numberFormatCommaTwoFraction(
                  totalPercentage / countPercentage
                )}{' '}
                %
              </th>
            } */}
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const PrintingVolume = (props) => {
  const { consolidatePrintVolumeReport, press, isLoading } = props;
  const { t, i18n } = useTranslation();
  let item = consolidatePrintVolumeReport.find(
    (index) => index.idPress === press.idPress
  );

  if (item === undefined) {
    item = {
      tpiPeriodTotal: null,
      oneColPeriodTotal: null,
      calcTwoColPeriodTotal: null,
      epmPeriodTotal: null,
    };
  }

  if (isLoading) {
    return <ProgressIndicator appearance="linear" />
  }

  return (
    <div className="table-responsive">
      <table className="table table-striped table-sm">
        <tbody>
          <tr>
            <th>{t('report.details.printingVolume.tpi')}</th>
            <td align="right">
              {item.tpiPeriodTotal == null
                ? '-'
                : numberFormatComma(item.tpiPeriodTotal)}
            </td>
          </tr>
          <tr>
            <th>1SEP </th>
            <td align="right">
              {item.oneColPeriodTotal == null
                ? '-'
                : numberFormatComma(item.oneColPeriodTotal)}
            </td>
          </tr>
          <tr>
            <th>2SEP</th>
            <td align="right">
              {item.calcTwoColPeriodTotal == null
                ? '-'
                : numberFormatComma(item.calcTwoColPeriodTotal)}
            </td>
          </tr>
          <tr>
            <th>EPM</th>
            <td align="right">
              {item.epmPeriodTotal == null
                ? '-'
                : numberFormatComma(item.epmPeriodTotal)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const UnderstandCalculation = (props) => {
  const {
    consolidatePrintVolumeReport,
    activePress,
    costPerPrint,
    showAlertModal,
    configtable,
  } = props;
  const { t, i18n } = useTranslation();
  let item = consolidatePrintVolumeReport.find(
    (index) => index.idPress === activePress?.idPress
  );
  let costPerPrintData = costPerPrint.find(
    (index) => index.idPress === activePress?.idPress
  );
  if (item === undefined) {
    item = {
      tpiPeriodTotal: '-',
      oneColPeriodTotal: '-',
      calcTwoColPeriodTotal: '-',
      epmPeriodTotal: '-',
    };
  }
  if (costPerPrintData === undefined) {
    costPerPrintData = {};
  }
  let renderIt = null;
  /*
    Case1: press.series == 3 && press.compensationProgram == 1 -> GetCostPerPrintS3Compensation
    Case2: press != 4 && !Case1 -> GetCostPerPrint
    Case3: press.seres == 4 && (press.classification == '2000' || press.clasiffication == '3000') -> GetCostPerPrintPress2x3x
    Case4: press.seres == 4 && !(press.classification == '2000' || press.clasiffication == '3000') -> GetCostPerPrintPress1x
  */
  if (activePress?.series == 3 && activePress?.compensationProgram == 1) { //Case1
    // const hasSpecialCondition10 = activePress.specialConditionType.split(',').findIndex(sc => sc.trim() == '10') > -1;
    renderIt = (
      <div style={{ textAlign: 'left' }}>
        <p>{t('report.details.understand.series3.message2')}</p>
        <br />
        <p>
          <b>»</b>{' '}
          {
            <Trans i18nKey="report.details.understand.series3.item1">
              The quantity of each used supply (reported in iServe) multiplied
              by its price for the last 3 months is added. As the smaller items
              (OMPs and Mineral Oil) changes are not captured by iServe, a
              constant factor based on HP Lifespan is used to calculate its
              cost. We call this value of <b>Total Supply Spent</b>;
            </Trans>
          }
        </p>
        <br />
        <p>
          <b>»</b>
          {
            <Trans i18nKey="report.details.understand.series3.item2">
              The <b>Total Supply Spent</b> is divided by the{' '}
              <b>Total Impressions in the last 3 months</b> in order to get the
              <b> CPP before the bonus</b>;
            </Trans>
          }
        </p>
        <br />
        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.series3.item3">
            The result of the multiplication between the <b>CPP before bonus</b>
            and the <b>Total printing of the month</b> is the
            <b>Total Supply Spent in the month</b>;
          </Trans>
        </p>
        <br />
        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.series4.item4">
              The difference between <b>CPP Before Bonus</b> and <b>CPP Guaranteed</b> is
              multiplied by the <b>Total printing of the month</b> to find the value of the
              compensation;
          </Trans>
        </p>
        <br />
        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.series4.item5">
            The result of the <b>Total Supplies Spent in the month</b> minus the
            Compensation amount is divided by the <b>Total Impressions of the month.</b>
            The result of this calculus is the <b>CPP after compensation.</b>
          </Trans>
        </p>
        <br />
        <div>
          <table className="table table-striped table-hover table-bordered table-sm table-card-head">
            <thead>
              <tr>
              <th>{t('Description')}</th>
                <th align="left">{t('value')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Total Supply Spent</td>
                <td align="left">
                  US${' '}
                  {numberFormatCommaTwoFraction(
                    costPerPrintData.totalSupplySpent
                  )}
                </td>
              </tr>
              <tr>
                <td>Total Printing in the period</td>
                <td align="left">
                  {numberFormatComma(costPerPrintData.tpiPeriod)}
                </td>
              </tr>
              <tr>
                <td>CPP before the bonus</td>
                <td align="left">
                  US${' '}
                  {numberFormatCommaMinimunFraction(
                    costPerPrintData.cppBeforeBonus
                  )}
                </td>
              </tr>
              <tr>
                <td>Total Printing of the month</td>
                <td align="left">
                  {numberFormatComma(costPerPrintData.tpiMonth)}
                </td>
              </tr>
              <tr>
                <td>Total Supplies Spent in the month</td>
                <td align="left">
                  US${' '}
                  {numberFormatCommaTwoFraction(
                    costPerPrintData.totalSuppliesMonth
                  )}
                </td>
              </tr>
              {costPerPrintData.cppAfterBonus != null ? (
                <tr>
                  <td>CPP after bonus</td>
                  <td align="left">
                    US${' '}
                    {numberFormatCommaMinimunFraction(
                      costPerPrintData.cppAfterBonus
                    )}
                  </td>
                </tr>
              ) : undefined}
              {costPerPrintData.cppGuaranteed != null ? (
                <tr>
                  <td>CPP guaranteed</td>
                  <td align="left">
                    US${' '}
                    {numberFormatCommaMinimunFraction(
                      costPerPrintData.cppGuaranteed
                    )}
                  </td>
                </tr>
              ) : undefined}
              {costPerPrintData.cppDifference != null ? (
                <tr>
                  <td>CPP difference</td>
                  <td align="left">
                    {numberFormatCommaMinimunFraction(
                      costPerPrintData.cppDifference
                    )}
                  </td>
                </tr>
              ) : undefined}
              {costPerPrintData.compensation != null ? (
                <tr>
                  <td>Compensation</td>
                  <td align="left">
                    US${' '}
                    {numberFormatCommaTwoFraction(costPerPrintData.compensation)}
                  </td>
                </tr>
              ) : undefined}
            </tbody>
              <tfoot>
                <tr>
                  <th>CPP after Compensation</th>
                  <th align="left">
                    US${' '}
                    {numberFormatCommaMinimunFraction(
                      costPerPrintData.cppAfterCompensation
                    )}
                  </th>
                </tr>
              </tfoot>
          </table>
          <br />
            <div className="table-responsive">
              <table className="table table-striped table-hover table-bordered table-sm">
                <thead>
                  <tr>
                    <th scope="col">{t('Description')}</th>
                    <th scope="col">EPM</th>
                    <th scope="col">1SEP</th>
                    <th scope="col">2SEP</th>
                    {(costPerPrintData.flagOneshot)?(<>
                      <th scope="col">Oneshot</th>
                      <th scope="col">Multicolor</th>
                    </>):(<>
                      <th scope="col">Others</th>
                    </>)}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{t('CPP guaranteed')}</td>
                    <td align="right">
                      US${' '}
                      {costPerPrintData.cppGuaranteedEPM == null
                        ? '-'
                        : numberFormatCommaMinimunFraction(
                          costPerPrintData.cppGuaranteedEPM
                        )}
                    </td>
                    <td align="right">
                      US${' '}
                      {costPerPrintData.cppGuaranteed1Col == null
                        ? '-'
                        : numberFormatCommaMinimunFraction(
                          costPerPrintData.cppGuaranteed1Col
                        )}
                    </td>
                    <td align="right">
                      US${' '}
                      {costPerPrintData.cppGuaranteed2Col == null
                        ? '-'
                        : numberFormatCommaMinimunFraction(
                          costPerPrintData.cppGuaranteed2Col
                        )}
                    </td>
                    {(costPerPrintData.flagOneshot)?(<>
                      <td align="right">
                        US${' '}
                        {costPerPrintData.cppGuaranteedOneShot == null
                          ? '-'
                          : numberFormatCommaMinimunFraction(
                            costPerPrintData.cppGuaranteedOneShot
                          )}
                      </td>
                      <td align="right">
                        US${' '}
                        {costPerPrintData.cppGuaranteedOthers == null
                          ? '-'
                          : numberFormatCommaMinimunFraction(
                            costPerPrintData.cppGuaranteedOthers
                          )}  
                      </td>
                    </>):(<>
                        <td align="right">
                        US${' '}
                        {costPerPrintData.cppGuaranteedOthers == null
                          ? '-'
                          : numberFormatCommaMinimunFraction(
                            costPerPrintData.cppGuaranteedOthers
                          )}
                      </td>
                    </>)}
                    
                  </tr>
                  <tr>
                    <td>{t('CPP difference')}</td>
                    <td align="right">
                      US${' '}
                      {costPerPrintData.cppDifferenceEPM == null
                        ? '-'
                        : numberFormatCommaMinimunFraction(
                          costPerPrintData.cppDifferenceEPM
                        )}
                    </td>
                    <td align="right">
                      US${' '}
                      {costPerPrintData.cppDifference1Col == null
                        ? '-'
                        : numberFormatCommaMinimunFraction(
                          costPerPrintData.cppDifference1Col
                        )}
                    </td>
                    <td align="right">
                      US${' '}
                      {costPerPrintData.cppDifference2Col == null
                        ? '-'
                        : numberFormatCommaMinimunFraction(
                          costPerPrintData.cppDifference2Col
                        )}
                    </td>
                    {(costPerPrintData.flagOneshot)?(<>
                      <td align="right">
                        US${' '}
                        {costPerPrintData.cppDifferenceOneShot == null
                          ? '-'
                          : numberFormatCommaMinimunFraction(
                            costPerPrintData.cppDifferenceOneShot
                          )}
                      </td>
                      <td align="right">
                        US${' '}
                        {costPerPrintData.cppDifferenceOthers == null
                          ? '-'
                          : numberFormatCommaMinimunFraction(
                            costPerPrintData.cppDifferenceOthers
                          )}  
                      </td>
                    </>):(<>
                      <td align="right">
                        US${' '}
                        {costPerPrintData.cppDifferenceOthers == null
                          ? '-'
                          : numberFormatCommaMinimunFraction(
                            costPerPrintData.cppDifferenceOthers
                          )}
                      </td>
                    </>)}
                  </tr>
                  <tr>
                    <td>{t('totalprintedimp')}</td>
                    {(costPerPrintData.totalEPMMonth != null ? (
                      <td align="right">
                        {numberFormatComma(costPerPrintData.totalEPMMonth)}
                      </td>
                    ) : undefined)}
                    {(costPerPrintData.total1ColMonth != null ? (
                      <td align="right">
                        {numberFormatComma(costPerPrintData.total1ColMonth)}
                      </td>
                    ) : undefined)}
                    {(costPerPrintData.total2ColMonth != null ? (
                      <td align="right">
                        {numberFormatComma(costPerPrintData.total2ColMonth)}
                      </td>
                    ) : undefined)}
                    {(costPerPrintData.flagOneshot)?(
                      (costPerPrintData.totalOneShotMonth != null && costPerPrintData.totalMultiColorMonth != null ? (<>
                        <td align="right">
                          {numberFormatComma(costPerPrintData.totalOneShotMonth)}
                        </td>
                        <td align="right">
                          {numberFormatComma(costPerPrintData.totalMultiColorMonth)}
                        </td>
                      </>) : undefined)
                    ):(
                      (costPerPrintData.tpiMonth != null ? (
                        <td align="right">
                          {numberFormatComma(costPerPrintData.tpiMonth-costPerPrintData.totalEPMMonth-costPerPrintData.total1ColMonth-costPerPrintData.total2ColMonth)}
                        </td>
                      ) : undefined)
                    )}
                  </tr>
                  <tr>
                    <td>{t('Compensation')}</td>
                    <td align="right">
                      US${' '}
                      {costPerPrintData.compensationEPM == null
                        ? '-'
                        : numberFormatCommaTwoFraction(
                          costPerPrintData.compensationEPM
                        )}
                    </td>
                    <td align="right">
                      US${' '}
                      {costPerPrintData.compensation1Col == null
                        ? '-'
                        : numberFormatCommaTwoFraction(
                          costPerPrintData.compensation1Col
                        )}
                    </td>
                    <td align="right">
                      US${' '}
                      {costPerPrintData.compensation2Col == null
                        ? '-'
                        : numberFormatCommaTwoFraction(
                          costPerPrintData.compensation2Col
                        )}
                    </td>
                    {(costPerPrintData.flagOneshot)?(<>
                      <td align="right">
                        US${' '}
                        {costPerPrintData.compensationOneShot == null
                          ? '-'
                          : numberFormatCommaTwoFraction(
                            costPerPrintData.compensationOneShot
                          )}
                      </td>
                      <td align="right">
                        US${' '}
                        {costPerPrintData.compensationOthers == null
                          ? '-'
                          : numberFormatCommaTwoFraction(
                            costPerPrintData.compensationOthers
                          )}  
                      </td>
                    </>):(<>
                        <td align="right">
                      US${' '}
                      {costPerPrintData.compensationOthers == null
                        ? '-'
                        : numberFormatCommaTwoFraction(
                          costPerPrintData.compensationOthers
                        )}
                    </td>
                    </>)}
                  </tr>
                  <tr>
                    <td>{t('Total Compensation')}</td>
                    <td align="center" colSpan={(costPerPrintData.flagOneshot)?("5"):("4")}>
                      US${' '}
                      {costPerPrintData.totalCompensation == null
                        ? '-'
                        : numberFormatCommaTwoFraction(
                          costPerPrintData.totalCompensation
                        )}
                    </td>
                  </tr>
                  <tr>
                    <th>{t('CPP after Compensation')}</th>
                    <td align="center" colSpan={(costPerPrintData.flagOneshot)?("5"):("4")}>
                      <strong>
                      US${' '}
                      {costPerPrintData.cppAfterCompensation == null
                        ? '-'
                        : numberFormatCommaMinimunFraction(
                          costPerPrintData.cppAfterCompensation
                        )}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
      </div>
    );
  }
  else if (activePress?.series !== 4 && activePress?.series!==5 && activePress?.series!==6) { //Case2
    renderIt = (
      <div style={{ textAlign: 'left' }}>
        <p>{t('report.details.understand.series3.message')}</p>
        <br />
        <p>
          <b>»</b>{' '}
          {
            <Trans i18nKey="report.details.understand.series3.item1">
              The quantity of each used supply (reported in iServe) multiplied
              by its price for the last 3 months is added. As the smaller items
              (OMPs and Mineral Oil) changes are not captured by iServe, a
              constant factor based on HP Lifespan is used to calculate its
              cost. We call this value of <b>Total Supply Spent</b>;
            </Trans>
          }
        </p>
        <br />
        <p>
          <b>»</b>
          {
            <Trans i18nKey="report.details.understand.series3.item2">
              The <b>Total Supply Spent</b> is divided by the{' '}
              <b>Total Impressions in the last 3 months</b> in order to get the
              <b> CPP before the bonus</b>;
            </Trans>
          }
        </p>
        <br />
        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.series3.item3">
            The result of the multiplication between the <b>CPP before bonus</b>
            and the <b>Total printing of the month</b> is the
            <b>Total Supply Spent in the month</b>;
          </Trans>
        </p>
        <br />
        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.series3.item4">
            The result of the <b>Total Supplies Spent in the month</b> minus the
            <b>Bonus of the month</b> is divided by the
            <b>Total Impressions of the month</b>. The result of this
            calculation is the <b>CPP after bonus</b>.
          </Trans>
        </p>
        <br />
        <div className="d-flex justify-content-center">
          <table className="table table-striped table-hover table-bordered table-sm table-card-head">
            <thead>
              <tr>
                <th>{t('Description')}</th>
                <th align="left">{t('value')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{t('Total Supply Spent')}</td>
                <td align="left">
                  US${' '}
                  {costPerPrintData.suppliesSpent == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.suppliesSpent
                    )}
                </td>
              </tr>
              {/* <tr>
                <td>{t('Total Printing in the period')}</td>
                <td align="left">
                  {costPerPrintData.tpiPeriodTotal == null
                    ? '-'
                    : numberFormatComma(costPerPrintData.tpiPeriodTotal)}
                </td>
              </tr> */}
              <tr>
                <td>{t('Total Printing in the period')}</td>
                <td align="left">
                  {costPerPrintData.tpiPeriodTotal == null
                    ? '-'
                    : numberFormatComma(costPerPrintData.tpiPeriodTotal)}
                </td>
              </tr>
              <tr>
                <td>{t('CPP before the bonus')}</td>
                <td align="left">
                  US${' '}
                  {costPerPrintData.cppBeforeBonus == null
                    ? '-'
                    : numberFormatCommaMinimunFraction(
                      costPerPrintData.cppBeforeBonus
                    )}
                </td>
              </tr>
              <tr>
                <td>{t('Total printing of the month')}</td>
                <td align="left">
                  {costPerPrintData.tpiMonthTotal == null
                    ? '-'
                    : numberFormatComma(costPerPrintData.tpiMonthTotal)}
                </td>
              </tr>
              <tr>
                <td>{t('Total Supplies Spent in the month')}</td>
                <td align="left">
                  US${' '}
                  {costPerPrintData.suppliesSpentThisMonth == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.suppliesSpentThisMonth
                    )}
                </td>
              </tr>
              {activePress?.rebateProgram == true &&
                costPerPrintData?.bonusOfTheMonth > 0 ? (
                <tr>
                  <td>{t('Bonus of the month')}</td>
                  <td align="left">
                    US${' '}
                    {costPerPrintData.bonusOfTheMonth == null
                      ? '-'
                      : numberFormatCommaTwoFraction(
                        costPerPrintData.bonusOfTheMonth
                      )}
                  </td>
                </tr>
              ) : undefined}
            </tbody>
            <tfoot>
              <tr>
                <th>{t('CPP after bonus')}</th>
                <th align="left">
                  US${' '}
                  {costPerPrintData.costPerPrint == null
                    ? '-'
                    : numberFormatCommaMinimunFraction(
                      costPerPrintData.costPerPrint
                    )}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  }else if  (configtable.whiteVisible) {//(activePress?.classification === '20000' || activePress?.classification === '30000') { //Case3
    //whitevisible 1
    renderIt = (
      <div style={{ textAlign: 'left' }}>
        <p>{t('report.details.understand.20000.message')}</p>
        <hr style={{ margin: '1px', height: '3px', visibility: 'hidden' }} />

        <p>
          <b>»</b> {t('report.details.understand.20000.item1')}
        </p>
        <hr style={{ margin: '1px', height: '3px', visibility: 'hidden' }} />

        <p>
          <b>»</b>{' '}
          <Trans i18nKey="report.details.understand.20000.item2">
            This value is divided by <b>Supply Spent in the Period</b> to find
            the <b>CPP Before the Compensation</b>;
          </Trans>
        </p>
        <hr style={{ margin: '1px', height: '3px', visibility: 'hidden' }} />

        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.20000.item3">
            The product between <b>CPP Before Compensation</b> and{' '}
            <b>Total Printing of the Month</b> results in{' '}
            <b>Supplies Spent of the Month</b>;
          </Trans>
        </p>
        <hr style={{ margin: '1px', height: '3px', visibility: 'hidden' }} />

        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.20000.item4">
            The difference between <b>CPP Before Compensation</b> the and the{' '}
            <b>CPP Guaranteed</b> is multiplied by the{' '}
            <b>Total Printing of the Month</b> to find the <b>Compensation</b>;
          </Trans>
        </p>
        <hr style={{ margin: '1px', height: '3px', visibility: 'hidden' }} />
        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.20000.item5">
            The <b>CPP After Compensation</b> is calculated from
            <b> Supplies Spent of the Month</b> minus<b> Total Compensation </b>
            that is divided by <b>Total Printing of the Month</b>.
          </Trans>
        </p>
        <hr style={{ margin: '1px', height: '3px', visibility: 'hidden' }} />

        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.20000.item6">
            The <b>Supply Spent in the Period</b> is split into the colors
            through the <b>Dry Cost</b> distribution (costs related to PIP, BID,
            BID Roller and Blanket), according to the
            <b> percentage of printings</b>;
          </Trans>
        </p>
        <hr style={{ margin: '1px', height: '3px', visibility: 'hidden' }} />

        <p>
          <Trans i18nKey="report.details.understand.20000.item7">
            The percentage of WHITE Printings in the period is calculated by
            dividing the WHITE Printing in the Period by the
            <b> Total Printing in the Period</b>;
          </Trans>
        </p>
        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.20000.item8">
            This percentage multiplies the <b>Dry Cost</b> added by OMP rate to
            have the White Spent in the Period;
          </Trans>
        </p>
        <hr style={{ margin: '1px', height: '3px', visibility: 'hidden' }} />

        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.20000.item9">
            The difference of the <b>Supply Spent in the Period</b> in the month
            and White Spent is the Costs CMYKOVG.
          </Trans>
        </p>
        <hr style={{ margin: '1px', height: '3px', visibility: 'hidden' }} />

        <p>
          <b>»</b>
          {t('report.details.understand.20000.item10')}
        </p>
        <br />
        <div className="table-responsive">
          <table className="table table-striped table-hover table-bordered table-sm table-card-head">
            <thead>
              <tr>
                <th scope="col">{t('Description')}</th>
                <th scope="col">Total</th>
                <th scope="col">White</th>
                <th scope="col">CMYKOVG</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{t('Total printing of the month')}</td>
                <td align="right">
                  {costPerPrintData.totalPrintMonth == null
                    ? '-'
                    : numberFormatComma(costPerPrintData.totalPrintMonth)}
                </td>
                <td align="right">
                  {costPerPrintData.totalPrintMonthWhite == null
                    ? '-'
                    : numberFormatComma(costPerPrintData.totalPrintMonthWhite)}
                </td>
                <td align="right">
                  {costPerPrintData.totalPrintMonthCMYKOVG == null
                    ? '-'
                    : numberFormatComma(
                      costPerPrintData.totalPrintMonthCMYKOVG
                    )}
                </td>
              </tr>
              <tr>
                <td>{t('Total printing in the period')}</td>
                <td align="right">
                  {costPerPrintData.totalPrintPeriod == null
                    ? '-'
                    : numberFormatComma(costPerPrintData.totalPrintPeriod)}
                </td>
                <td align="right">
                  {costPerPrintData.totalPrintPeriodWhite == null
                    ? '-'
                    : numberFormatComma(costPerPrintData.totalPrintPeriodWhite)}
                </td>
                <td align="right">
                  {costPerPrintData.totalPrintPeriodCMYKOVG == null
                    ? '-'
                    : numberFormatComma(
                      costPerPrintData.totalPrintPeriodCMYKOVG
                    )}
                </td>
              </tr>
              <tr>
                <td>{t('Printing distribution in the period')}</td>
                <td align="right">
                  {costPerPrintData.printDistribution == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.printDistribution
                    )}
                  %
                </td>
                <td align="right">
                  {costPerPrintData.printDistributionWhite == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.printDistributionWhite
                    )}
                  %
                </td>
                <td align="right">
                  {costPerPrintData.printDistributionCMYKOVG == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.printDistributionCMYKOVG
                    )}
                  %
                </td>
              </tr>
              <tr>
                <td>{t('Total Supply Spent')}</td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.totalSuppliesSpent == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.totalSuppliesSpent
                    )}
                </td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.totalSuppliesSpentWhite == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.totalSuppliesSpentWhite
                    )}
                </td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.totalSuppliesSpentCMYKOVG == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.totalSuppliesSpentCMYKOVG
                    )}
                </td>
              </tr>
              <tr>
                <td>{t('CPP before the bonus')}</td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.cppBeforeBonus == null
                    ? '-'
                    : numberFormatCommaMinimunFraction(
                      costPerPrintData.cppBeforeBonus
                    )}
                </td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.cppBeforeBonusWhite == null
                    ? '-'
                    : numberFormatCommaMinimunFraction(
                      costPerPrintData.cppBeforeBonusWhite
                    )}
                </td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.cppBeforeBonusCMYKOVG == null
                    ? '-'
                    : numberFormatCommaMinimunFraction(
                      costPerPrintData.cppBeforeBonusCMYKOVG
                    )}
                </td>
              </tr>
              {costPerPrintData.pTax!=0 ?(
                <tr>
                  <td>Ptax</td>
                  <td align="right">{costPerPrintData.pTax}%</td>
                </tr>
              ):undefined}
              <tr>
                <td>{t('Total Supplies Spent in the month')}</td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.totalSuppliesMonth == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.totalSuppliesMonth
                    )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="table-responsive">
          <table className="table table-striped table-hover table-bordered table-sm table-card-head">
            <thead>
              <tr>
                <th scope="col">{t('Description')}</th>
                <th scope="col">White</th>
                <th scope="col">CMYKOVG</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{t('CPP guaranteed')}</td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.cppGuaranteedWhite == null
                    ? '-'
                    : numberFormatCommaMinimunFraction(
                      costPerPrintData.cppGuaranteedWhite
                    )}
                </td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.cppGuaranteedCMYKOVG == null
                    ? '-'
                    : numberFormatCommaMinimunFraction(
                      costPerPrintData.cppGuaranteedCMYKOVG
                    )}
                </td>
              </tr>
              <tr>
                <td>{t('CPP difference')}</td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.cppDifferenceWhite == null
                    ? '-'
                    : numberFormatCommaMinimunFraction(
                      costPerPrintData.cppDifferenceWhite
                    )}
                </td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.cppDifferenceCMYKOVG == null
                    ? '-'
                    : numberFormatCommaMinimunFraction(
                      costPerPrintData.cppDifferenceCMYKOVG
                    )}
                </td>
              </tr>
              <tr>
                <td>{t('Compensation')}</td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.compensationWhite == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.compensationWhite
                    )}
                </td>
                <td align="right">
                  US${' '}
                  {costPerPrintData.compensationCMYKOVG == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.compensationCMYKOVG
                    )}
                </td>
              </tr>
              <tr>
                <td>{t('Total Compensation')}</td>
                <td align="center" colSpan="2">
                  US${' '}
                  {costPerPrintData.totalCompensation == null
                    ? '-'
                    : numberFormatCommaTwoFraction(
                      costPerPrintData.totalCompensation
                    )}
                </td>
              </tr>
              <tr>
                <th>{t('CPP after Compensation')}</th>
                <td align="center" colSpan="2">
                  US${' '}
                  {costPerPrintData.cppAfterCompensation == null
                    ? '-'
                    : numberFormatCommaMinimunFraction(
                      costPerPrintData.cppAfterCompensation
                    )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
  else { //Case4 (series 1x)
    renderIt = (
      <div style={{ textAlign: 'left' }}>
        <p>{t('report.details.understand.series3.message2')}</p>
        <br />
        <p>
          <b>»</b>{' '}
          {
            <Trans i18nKey="report.details.understand.series3.item1">
              The quantity of each used supply (reported in iServe) multiplied
              by its price for the last 3 months is added. As the smaller items
              (OMPs and Mineral Oil) changes are not captured by iServe, a
              constant factor based on HP Lifespan is used to calculate its
              cost. We call this value of <b>Total Supply Spent</b>;
            </Trans>
          }
        </p>
        <br />
        <p>
          <b>»</b>
          {
            <Trans i18nKey="report.details.understand.series3.item2">
              The <b>Total Supply Spent</b> is divided by the{' '}
              <b>Total Impressions in the last 3 months</b> in order to get the
              <b> CPP before the bonus</b>;
            </Trans>
          }
        </p>
        <br />
        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.series3.item3">
            The result of the multiplication between the <b>CPP before bonus</b>
            and the <b>Total printing of the month</b> is the
            <b>Total Supply Spent in the month</b>;
          </Trans>
        </p>
        <br />
        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.series4.item4">
              The difference between <b>CPP Before Bonus</b> and <b>CPP Guaranteed</b> is
              multiplied by the <b>Total printing of the month</b> to find the value of the
              compensation;
          </Trans>
        </p>
        <br />
        <p>
          <b>»</b>
          <Trans i18nKey="report.details.understand.series4.item5">
            The result of the <b>Total Supplies Spent in the month</b> minus the
            Compensation amount is divided by the <b>Total Impressions of the month.</b>
            The result of this calculus is the <b>CPP after compensation.</b>
          </Trans>
        </p>
        <br />
        <div>
          <table className="table table-striped table-hover table-bordered table-sm table-card-head">
            <thead>
              <tr>
              <th>{t('Description')}</th>
                <th align="left">{t('value')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Total Supply Spent</td>
                <td align="left">
                  US${' '}
                  {numberFormatCommaTwoFraction(
                    costPerPrintData.totalSupplySpent
                  )}
                </td>
              </tr>
              <tr>
                <td>Total Printing in the period</td>
                <td align="left">
                  {numberFormatComma(costPerPrintData.tpiPeriod)}
                </td>
              </tr>
              {costPerPrintData.printingInBlack != null ? (
                <>
                  <tr>
                    <td>CPP in the period</td>
                    <td align="left">
                      US${' '}
                      {numberFormatCommaTwoFraction(
                        costPerPrintData.cppBeforeBonus
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Total Printing of the month</td>
                    <td align="left">
                      {numberFormatComma(costPerPrintData.tpiMonth)}
                    </td>
                  </tr>
                </>
              ) : undefined}
              {costPerPrintData.pTax != null && costPerPrintData.printingInBlack == null && costPerPrintData.pTax!=0? (
                <tr>
                  <td>{t('Ptax Difference')}</td>
                  <td align="left">
                    {costPerPrintData.pTax == null
                      ? '-'
                      : numberFormatCommaTwoFraction(
                        costPerPrintData.pTax * 100
                      )}
                    %
                  </td>
                </tr>
              ) : undefined}
              {costPerPrintData.printingInBlack == null ? (
                <tr>
                  <td>CPP before the bonus</td>
                  <td align="left">
                    US${' '}
                    {numberFormatCommaMinimunFraction(
                      costPerPrintData.cppBeforeBonus
                    )}
                  </td>
                </tr>
              ) : undefined}
              <tr>
                <td>Total Supplies Spent in the month</td>
                <td align="left">
                  US${' '}
                  {numberFormatCommaTwoFraction(
                    costPerPrintData.totalSuppliesMonth
                  )}
                </td>
              </tr>
              {costPerPrintData.cppAfterBonus != null && costPerPrintData.printingInBlack == null ? (
                <tr>
                  <td>CPP after bonus</td>
                  <td align="left">
                    US${' '}
                    {numberFormatCommaMinimunFraction(
                      costPerPrintData.cppAfterBonus
                    )}
                  </td>
                </tr>
              ) : undefined}
              {costPerPrintData.cppGuaranteed != null && costPerPrintData.printingInBlack == null ? (
                <tr>
                  <td>CPP guaranteed</td>
                  <td align="left">
                    US${' '}
                    {numberFormatCommaMinimunFraction(
                      costPerPrintData.cppGuaranteed
                    )}
                  </td>
                </tr>
              ) : undefined}
              {costPerPrintData.cppDifference != null && costPerPrintData.printingInBlack == null ? (
                <tr>
                  <td>CPP difference</td>
                  <td align="left">
                    {numberFormatCommaMinimunFraction(
                      costPerPrintData.cppDifference
                    )}
                  </td>
                </tr>
              ) : undefined}
              {costPerPrintData.printingInBlack != null ? (
                <>
                  <tr>
                    <td>Printing in Black</td>
                    <td align="left">
                      {numberFormatComma(costPerPrintData.printingInBlack)}
                    </td>
                  </tr>
                  <tr>
                    <td>CPP guaranteed Black</td>
                    <td align="left">
                      {numberFormatCommaMinimunFraction(costPerPrintData.cppGuaranteedBlack)}
                    </td>
                  </tr>
                  <tr>
                    <td>CPP difference Black</td>
                    <td align="left">
                      US${' '}
                      {numberFormatCommaMinimunFraction(costPerPrintData.cpPdifferenceBlack)}
                    </td>
                  </tr>
                  <tr>
                    <td>Compensation Black</td>
                    <td align="left">
                      US${' '}
                      {numberFormatCommaTwoFraction(costPerPrintData.compensationBlack)}
                    </td>
                  </tr>

                  <tr>
                    <td>Printing in CMY</td>
                    <td align="left">
                      {numberFormatComma(costPerPrintData.printinginCMY)}
                    </td>
                  </tr>
                  <tr>
                    <td>CPP guaranteed CMY</td>
                    <td align="left">
                      {numberFormatCommaMinimunFraction(costPerPrintData.cppGuaranteedCMY)}
                    </td>
                  </tr>
                  <tr>
                    <td>CPP difference CMY</td>
                    <td align="left">
                      US${' '}
                      {numberFormatCommaMinimunFraction(costPerPrintData.cpPdifferenceCMY)}
                    </td>
                  </tr>
                  <tr>
                    <td>Compensation CMY</td>
                    <td align="left">
                      US${' '}
                      {numberFormatCommaTwoFraction(costPerPrintData.compensationCMY)}
                    </td>
                  </tr>
                </>
              ) : undefined}
              {costPerPrintData.compensation != null ? (
                <tr>
                  <td>{costPerPrintData.printingInBlack == null ? 'Compensation' : 'Total Compensation'}</td>
                  <td align="left">
                    US${' '}
                    {numberFormatCommaTwoFraction(costPerPrintData.compensation)}
                  </td>
                </tr>
              ) : undefined}
              <tr>
                <td>{t('Total printing of the month')}</td>
                <td align="left">
                  {costPerPrintData.printinginCMY == null
                    ? '-'
                    : numberFormatComma(costPerPrintData.printinginCMY)}
                </td>
              </tr>
              <tr>
                <th>CPP after Compensation</th>
                <th align="left">
                  US${' '}
                  {numberFormatCommaMinimunFraction(
                    costPerPrintData.cppAfterCompensation
                  )}
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <AlertModal
      title={t('button.understandCalc')}
      show={showAlertModal}
      onClose={() => props.onClose()}
      size="lg"
      css={{
        '.vn-modal--content': {
          width: '710px',
        },
      }}
    >
      {renderIt}
    </AlertModal>
  );
};

export { SuppliesReport, PrintingVolume, UnderstandCalculation, CPP };
